import { render, staticRenderFns } from "./ChatCarousel.vue?vue&type=template&id=c053b504&scoped=true&"
import script from "./ChatCarousel.vue?vue&type=script&lang=js&"
export * from "./ChatCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ChatCarousel.vue?vue&type=style&index=0&id=c053b504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c053b504",
  null
  
)

export default component.exports